export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-accent-100/60">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
          准备好探索雏田的同人世界了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          加入我们，发现更多精彩的雏田同人漫画、插画与二次创作作品
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/category/tongren-manhua"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即浏览
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="/about"
            className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            联系我们
          </a>
        </div>
      </div>
    </section>
  );
}